import React, { useRef } from "react";
import { EnabledForInsurer } from "../../redux/actions/InsBillAction";
import { useDispatch } from "react-redux";
import { getSnackbarSuccess, isLoadingAction } from "../../Utils/helper";

export const EnableForInsurer = ({ providerDetail,setProviderDetail }) => {
  const ref = useRef();
  console.log("first",providerDetail)
  const dispatch = useDispatch();
  const handleSubmit = async() => {
    isLoadingAction(true, dispatch);
    let res = await dispatch(
      EnabledForInsurer({
        appointmentId: providerDetail[0]?.appointmentId,
        clientId: providerDetail[0]?.clientId,
        caseNo: providerDetail[0]?.caseNo,
      })
    );
    console.log(res)
    if (res?.data?.status === true) {
        getSnackbarSuccess("success", res?.data?.message, dispatch);
        isLoadingAction(false, dispatch);
        setProviderDetail([])
        ref.current.click();
      } else {
        getSnackbarSuccess("error", res?.data?.message, dispatch);
        isLoadingAction(false, dispatch);
      }
  };
  return (
    <>
      <div class="modal-dialog modal-dialog-centered " role="document">
        <div class="modal-content" style={{ borderRadius: "1em" }}>
          <div className=" modal-body-active-popup popup-text">
            Are you sure you want to Enable For Insurer ?
          </div>
          <div className="modal-footer modal-footer-active-popup">
            <button
              type="button"
              className="btn btn-primary noshow_disable"
              style={{ width: "90px" }}
              onClick={handleSubmit}
            >
              Yes
            </button>
            <button
              type="button"
              className="btn btn-primary btn-logout-no"
              aria-label="Close"
              data-bs-dismiss="modal"
              ref={ref}
              //   onClick={handleClose}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
